import { render, staticRenderFns } from "./Ventil.vue?vue&type=template&id=4bf59efa&"
import script from "./Ventil.vue?vue&type=script&lang=js&"
export * from "./Ventil.vue?vue&type=script&lang=js&"
import style0 from "./Ventil.vue?vue&type=style&index=0&id=4bf59efa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports